import { SupportedLanguage } from "./languageStorage"

// 翻訳キャッシュは同期的にアクセスする必要があるため、
// Capacitor Preferences（非同期）ではなく localStorage を使用
const CACHE_STORAGE_KEY = "translation_cache"

const memoryCache = new Map<string, string>()

const makeCacheKey = (
    targetLanguage: SupportedLanguage,
    text: string
): string => `${targetLanguage}:${text}`

export const getCachedTranslation = (
    targetLanguage: SupportedLanguage,
    text: string
): string | undefined => {
    const key = makeCacheKey(targetLanguage, text)
    const cached = memoryCache.get(key)
    if (cached !== undefined) return cached

    try {
        const stored = localStorage.getItem(CACHE_STORAGE_KEY)
        if (stored) {
            const parsed = JSON.parse(stored) as Record<string, string>
            if (key in parsed) {
                memoryCache.set(key, parsed[key])
                return parsed[key]
            }
        }
    } catch {
        // ignore parse errors
    }
    return undefined
}

export const setCachedTranslation = (
    targetLanguage: SupportedLanguage,
    text: string,
    translation: string
): void => {
    const key = makeCacheKey(targetLanguage, text)
    memoryCache.set(key, translation)

    try {
        const stored = localStorage.getItem(CACHE_STORAGE_KEY)
        const parsed = stored
            ? (JSON.parse(stored) as Record<string, string>)
            : {}
        parsed[key] = translation
        localStorage.setItem(CACHE_STORAGE_KEY, JSON.stringify(parsed))
    } catch {
        // ignore storage errors
    }
}
